<template>

  <div class="col-12">
    <div class="row">

      <div class="col-12">
        <button class="btn btn-primary rounded-pill mx-1"
                data-toggle="modal" data-target="#domain-manager-create">
          افزودن
          <i class="bi bi-plus-circle"></i>
        </button>


        <!-- Modal -->
        <teleport to="body">
          <div class="modal fade" id="domain-manager-create" tabindex="-1" aria-labelledby="exampleModalLabel"
               aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-right" dir="rtl">
                  <div class="">
                    <h4>ساخت رکورد جدید</h4>
                    <domain-manager-form/>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </teleport>

        <button @click="buildDns()" class="btn btn-success rounded-pill mx-1">دخیره
          <i class="bi bi-check-circle"></i>
        </button>

      </div>

      <div class="col-12 my-2">
        <table class="table text-center table-striped">
          <thead>
          <tr>
            <th scope="col">دامنه</th>
            <th scope="col">مقدار</th>
            <th scope="col">نوع</th>
            <th scope="col">#</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in projectDns">
            <th scope="row">{{ item.value['domain'] }}</th>
            <td>{{ item.value['value'] }}</td>
            <td>{{ item.value['dns_type'] }}</td>
            <td>
              <button class="btn btn-success rounded-pill mx-1"
                      data-toggle="modal" :data-target="`#domain-manager-update-${item.id}`"
              >ویرایش
                <i class="bi bi-pen"></i>
              </button>

              <teleport to="body">
                <div class="modal fade" :id="`domain-manager-update-${item.id}`" tabindex="-1"
                     aria-labelledby="exampleModalLabel"
                     aria-hidden="true">
                  <div class="modal-dialog">
                    <div class="modal-content">
                      <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body text-right" dir="rtl">
                        <div class="">
                          <h4>ویرایش رکورد</h4>
                          <domain-manager-form :item="item"/>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </teleport>

              <button @click="deleteItem(item)" class="btn btn-danger rounded-pill mx-1">حذف
                <i class="bi bi-trash"></i>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>


    </div>

  </div>

</template>


<script>
import {mapGetters} from "vuex";
import DomainManagerForm from "@/components/DomainManager/DomainManagerForm.vue";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default {
  name: 'DomainManager',
  components: {DomainManagerForm},
  computed: {
    ...mapGetters({
      project: "ProjectAlpha/getProject",
    }),
    projectDns() {
      if (this.project == null) return []

      return this.project.meta.filter(item => {
        if (item.name == 'dns_manager') {
          item.value = JSON.parse(item.value)
          return item
        }
      })


    }
  },
  methods: {
    deleteItem(item) {
      let form = {
        project_id: item.metable_id,
        item_id: item.id,
      }
      if (confirm('آیا از حذف اطمینان دارید؟')) {
        this.$store.dispatch('DnsManager/deleteDnsRecord', form).then((res) => {
          toast('عملیات با موفقیت انجام شد.', 'عملیات با موفقیت انجام شد.')
          this.$store.dispatch('ProjectAlpha/getProject', form)
        })
      }

    },
    buildDns() {
      let form = {
        project_id: this.project.id
      }
      this.$store.dispatch('DnsManager/buildDnsRecord', form).then((res) => {
        toast('عملیات با موفقیت انجام شد.', 'عملیات با موفقیت انجام شد.')
      })
    }
  }
}
</script>


<style scoped>


</style>